import { EventEmitter, Inject, Injectable, Output, PipeTransform } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EntityService } from '@services/entity/entity.service';
import { RfidCard } from '@models/rfidCard';
import { Observable } from 'rxjs';
import { RfidCardDto } from '@dto/rfidCardDto';


@Injectable({
  providedIn: 'root'
})
export class RfidCardsService extends EntityService {

  public entityRoute = "rfidCards";

  constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(http, baseUrl);
  }

  @Output() rfidCardCreatedEvent = new EventEmitter<RfidCardDto>();
  emitCreated(createdRfidCard: RfidCardDto) {
    this.rfidCardCreatedEvent.emit(createdRfidCard);
  }

  getRfidCardsOfCurrentCustomer(): Observable<RfidCardDto[]> {
    return this.http.get<RfidCardDto[]>(this.baseUrl + 'api/rfidCards');
  }

  getRfidCardsOfCustomer(customerId: number): Observable<RfidCardDto[]> {
    return this.http.get<RfidCardDto[]>(this.baseUrl + 'api/customers/' + customerId + '/rfidCards');
  }

  getRfidCard(id: number): Observable<RfidCardDto> {
    return this.http.get<RfidCardDto>(this.baseUrl + 'api/rfidCards/' + id);
  }

  createRfidCard(rfidCard: RfidCard): Observable<RfidCardDto> {
    return this.http.post<RfidCardDto>(this.baseUrl + 'api/rfidCards', rfidCard);
  }

  createRfidCardForCustomer(customerId: number, rfidCard: RfidCard): Observable<RfidCardDto> {
    return this.http.post<RfidCardDto>(this.baseUrl + 'api/customers/' + customerId + '/rfidCard', rfidCard);
  }

  createRfidCardsForCustomer(customerId: number, rfidCards: RfidCardDto[]): Observable<RfidCardDto[]> {
    return this.http.post<RfidCardDto[]>(this.baseUrl + 'api/customers/' + customerId + '/rfidCards', rfidCards);
  }

  search(searchTerm: string): Observable<RfidCardDto[]> {
    return this.http.get<RfidCardDto[]>(`${this.baseUrl}api/rfidCards/search/${searchTerm}`);
  }

  static matches(rfidCard: RfidCardDto, term: string, pipe?: PipeTransform) {
    return rfidCard.idTag?.toLowerCase().includes(term.toLowerCase())
      || rfidCard.userFirstName?.toLowerCase().includes(term.toLowerCase())
      || rfidCard.userLastName?.toLowerCase().includes(term.toLowerCase())
      || rfidCard.tagsString?.toLowerCase().includes(term.toLowerCase())
      || rfidCard.note?.toLowerCase().includes(term.toLowerCase());
    //var datePipe = new DEDatePipe();
    //var lastauthdate = datePipe.transform(rfidCard.lastAuthorizationDate);

    //return rfidCard.idTag?.toLowerCase().includes(term.toLowerCase())
    //  || rfidCard.userFirstName?.toLowerCase().includes(term.toLowerCase())
    //  || rfidCard.userLastName?.toLowerCase().includes(term.toLowerCase())
    //  || lastauthdate?.includes(term.toLowerCase())
    //  || rfidCard.lastUsedChargingStationName?.toLowerCase().includes(term.toLowerCase());
  }
}
